export default {
    nftContract : "0x2467b97ab8470c998069cFD09ec397b098Ef14DD",
    // stakingContract:"0x2fDdaC6b94FEe743a8c5bE0F81373e91944d12a2"
}